import { SvgIcon } from '@mui/material';
import { ReactComponent as WalletSVG } from "./wallet-tc.svg";

export default function IconAndroidWalletTC(props) {
  return <SvgIcon {...props} component={WalletSVG} viewBox="0 0 115 34" />;
}